var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilledFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6673 4.66667C22.6673 4.29848 22.3688 4 22.0007 4H10.0007C9.63246 4 9.33398 4.29848 9.33398 4.66667V27.332C9.33398 27.732 9.65967 27.9975 10.0007 28C10.166 28.0012 10.3349 27.9406 10.4721 27.8034L15.5292 22.7462C15.7896 22.4859 16.2117 22.4859 16.4721 22.7462L21.5292 27.8034C21.6637 27.9379 21.8288 27.9988 21.991 28C22.3355 28.0025 22.6673 27.7358 22.6673 27.332V4.66667Z",
    fill: "#E20613"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledFlag);
export default __webpack_public_path__ + "static/media/filled-flag.ab912179422dbd5dc7e2e1364687787c.svg";
export { ForwardRef as ReactComponent };